import { render, staticRenderFns } from "./OurServicesTable.vue?vue&type=template&id=15610f90"
import script from "./OurServicesTable.vue?vue&type=script&lang=js"
export * from "./OurServicesTable.vue?vue&type=script&lang=js"
import style0 from "./OurServicesTable.vue?vue&type=style&index=0&id=15610f90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports